import React from "react";
import TableTennisData from "../pagesData/tableTennisData";
import { SectionHeader } from "../../../components";

class TableTennisGallery extends React.Component {
  constructor() {
    super();
    this.state = {
      gallerySection: TableTennisData,
    };
  }

  render() {
    return (
      <>
        {/* Gallery Section */}
        <div
          className="section-full text-center text-white bg-img-fix content-inner overlay-black-middle our-projects-galery"
          style={{
            backgroundImage: "url(./assets/images/background/bg1.jpg)",
          }}
        >
          <div className="container">
            <SectionHeader titleSub={`Table Tennis Gallery`} />

            {/* Gallery Grid */}
            <div className="row">
              <ul className="dlab-gallery-listing row list-unstyled p-0 m-0">
                {this.state.gallerySection.map(({ id, alt, img }) => (
                  <li
                    key={id}
                    className="col-lg-4 col-md-4 col-sm-6 col-12 mb-4 d-flex"
                  >
                    <div className="w-100 d-flex flex-column">
                      <div
                        className="dlab-box dlab-gallery-box h-100"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div
                          className="dlab-media dlab-img-overlay1 dlab-img-effect rotate"
                          style={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <a href="#">
                            <img
                              src={img}
                              alt={alt}
                              className="img-fluid"
                              style={{
                                height: "250px",
                                objectFit: "cover",
                                width: "100%",
                              }}
                            />
                          </a>
                          <div className="overlay-bx">
                            <div className="overlay-icon">
                              <a href={img} className="mfp-link">
                                <i className="fa fa-picture-o icon-bx-xs"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default TableTennisGallery;
